import { render, staticRenderFns } from "./chaoozeRegion.vue?vue&type=template&id=3a4caf24&scoped=true&"
import script from "./chaoozeRegion.vue?vue&type=script&lang=js&"
export * from "./chaoozeRegion.vue?vue&type=script&lang=js&"
import style0 from "./chaoozeRegion.vue?vue&type=style&index=0&id=3a4caf24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4caf24",
  null
  
)

export default component.exports